import { render } from "./AudioComp.vue?vue&type=template&id=6079022a"
import script from "./AudioComp.vue?vue&type=script&lang=js"
export * from "./AudioComp.vue?vue&type=script&lang=js"

import "../assets/css/audio-comp.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__